<template>
    <div class="courses-single-page pb-4 pt-4">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div v-if="success" class="flat-row-half success">
                        <h1>Certificate Downloaded</h1>
                        
                        <p>Check your browser's download history for the certificate file</p>
                        
                    </div>
                   
                </div>
            </div>
        </div>
    </div>
</template>

<style>
    
</style>

<script>

    import MixinsCertificates from '../mixinsCertificates';
    import PDFJSViewer from '../components/PDFJSViewer';

    export default {
        name: 'Certificate',
        mixins: [MixinsCertificates],
        components: {
            PDFJSViewer,          
        },
        props: {

        },
        watch: {
        },
        computed: {
            isAuthenticated() {
                return this.$store.state.isAuthenticated;
            },
            certificateJWT() {
                return this.$route.params.id
            },
        },
        data() {
            return {
                course: null,
                courseDetails: null,
                user: null
            }
        },
        methods: {
           
        },
        async mounted() {

            console.log("Certificate view");

            debugger;
            //get certificate information
            var result = await this.web("/courses/certificate/usercourse/" + this.certificateJWT, "Loading certificate details");

            debugger;
            this.course = result.course;
            this.courseDetails = result.courseDetails;
            this.user = result.user;

            console.log("downloadCertificate");
            var pdfBytes = await this.generateCertificate(this.course, this.courseDetails, this.user);

            console.log("Opening PDF in Browser");
            var bytes = new Uint8Array(pdfBytes); // Convert to Uint8Array
            var blob = new Blob([bytes], { type: "application/pdf" }); // Create a Blob

            var blobUrl = URL.createObjectURL(blob); // Create a Blob URL

            // Open the PDF in a new tab/window
            //window.open(blobUrl, '_blank');

            // Replace the current page with the PDF view
            window.location.href = blobUrl;
        }
    }

</script>